import React from "react";
import styled from "styled-components";

import { LandingButton, SpanTag } from "@tm/static";
import { theme } from "@tm/utility/global";

import { useBreakpointV2 } from "@tm/ui-widgets";
import DnldIcon from "../../../../icons/DnldIcon.svg";
import { deviceType } from "../../../../utils";
import {
  Divider,
  PolicyStatusCard,
  PolicyStatusText,
  Spinner,
} from "../../OrderDetailV2.style";
import type { OrderDetailV2PolicyDownloadProps } from "../../types";

const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
`;

const DownloadButtonWrapper = styled.div`
  width: 100%;
  @media ${deviceType.mobile} {
    margin-bottom: 0;
  }
`;

const StatusCardWrapper = styled.div`
  width: 100%;
`;

const StatusIcon = styled.img`
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  align-self: center;
`;

export const OrderDetailV2PolicyDownload: React.FC<
  OrderDetailV2PolicyDownloadProps
> = ({
  title,
  subTitle,
  desc,
  titleColor,
  subTitleColor,
  descColor,
  showSpinner,
  statusIcon,
  downloadAction,
  newPolicyUrl,
  showPolicyUpdateSection,
}: OrderDetailV2PolicyDownloadProps) => {
  const showDownloadButton = downloadAction?.isVisible === true;
  const device = useBreakpointV2();
  const handleDownload = () => {
    if (downloadAction?.isEnabled === false) return;
    if (newPolicyUrl) {
      const url = newPolicyUrl.startsWith("http")
        ? newPolicyUrl
        : `https://${newPolicyUrl}`;
      window.open(url, "_blank");
    }
  };

  return (
    <SectionWrapper>
      {showDownloadButton && (
        <>
          <DownloadButtonWrapper>
            <LandingButton
              customTitle={
                downloadAction?.label
                  ? String(downloadAction.label)
                  : "DOWNLOAD POLICY"
              }
              onClick={handleDownload}
              customWidth="100%"
              customHeight="44px"
              fontSize="md"
              disableState={downloadAction?.isEnabled === false}
              btnLeftIcon={downloadAction?.icon ?? DnldIcon.src}
              contentAlign="left"
            />
          </DownloadButtonWrapper>
        </>
      )}

      {showPolicyUpdateSection && (
        <StatusCardWrapper>
          {device === "sm" && <Divider />}
          <PolicyStatusCard>
            <PolicyStatusText>
              <SpanTag fontSize="md" color={titleColor || theme.greyText7}>
                {title}
              </SpanTag>
              {subTitle ? (
                <SpanTag fontSize="xs" color={subTitleColor || theme.greyText7}>
                  {subTitle}
                </SpanTag>
              ) : null}
              {desc ? (
                <SpanTag fontSize="xs" color={descColor || theme.greyText7}>
                  {desc}
                </SpanTag>
              ) : null}
            </PolicyStatusText>
            {showSpinner ? (
              <Spinner />
            ) : statusIcon ? (
              <StatusIcon src={statusIcon} alt="" />
            ) : null}
          </PolicyStatusCard>
        </StatusCardWrapper>
      )}
    </SectionWrapper>
  );
};
